import gql from 'graphql-tag';

export const GET_MERCHANT_OFFER_SEGMENTS = gql`
  query GetMerchantOfferSegments($params: MerchantOfferSegmentsInput!) {
    merchantOfferSegments(params: $params) {
      cashbackPercentage
      cashbackDollarAmt
      segmentId
    }
  }
`;
